
import { Header } from '@/components/layout/Header';

export function Admin() {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
            <Header />

            <main style={{ flex: 1, overflow: 'auto', padding: 'var(--spacing-2xl)' }}>
                <div className="container">
                    <h1 style={{ marginBottom: 'var(--spacing-xl)' }}>System Administration</h1>

                    <div className="panel">
                        <p style={{ color: 'var(--color-text-secondary)' }}>
                            System admin features for managing all users, organizations, and scripts.
                        </p>
                        <p style={{ color: 'var(--color-text-tertiary)', fontSize: '0.875rem', marginBottom: 0 }}>
                            Full implementation requires backend admin endpoints.
                        </p>
                    </div>
                </div>
            </main>
        </div>
    );
}
